import { useState } from 'react'
import {
  Popover,
  IconButton,
  Typography,
  Box,
  Stack,
  Fade,
} from '@mui/material'
import ExclamationBubleSvg from '~/@ui/_sharedSvgs/ui/ExclamationBuble.svg?react'

type Props = { text?: string; className?: string }

export const InfoBubble = ({ text, className = '' }: Props) => {
  const isDev = import.meta.env.VITE_REACT_HIDE_DEV !== '1'

  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null)

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)
  const id = open ? 'info-popover' : undefined

  if (!text && !isDev) return null

  return (
    <Stack className={`w-6 h-6 ${className}`}>
      <IconButton onClick={handleClick} className="p-0">
        <Fade in={open} timeout={200}>
          <Box
            sx={{
              position: 'absolute',
              top: '-1px',
              width: 0,
              height: 0,
              borderLeft: '8px solid transparent',
              borderRight: '8px solid transparent',
              borderTop: '8px solid #E0E5EC',
            }}
          />
        </Fade>
        <ExclamationBubleSvg className={`w-6 h-6`} />
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        PaperProps={{
          style: {
            width: 'fit-content',
            borderRadius: '10px',
            backgroundColor: '#E0E5EC',
            backdropFilter: 'blur(5px)',
            WebkitBackdropFilter: 'blur(5px)',
            position: 'relative',
            boxShadow: 'none',
            overflow: 'visible',
          },
        }}>
        <Stack className="w-fit max-w-64 gap-1 p-3">
          <Typography className="text-[10px]/[13px] font-medium text-zGrey600">
            Vysvetlenie
          </Typography>
          <Typography className="text-sm font-medium text-zBlack200">
            {text}
          </Typography>
        </Stack>
      </Popover>
    </Stack>
  )
}
